
<template>
    <div class="center">
      <vs-dialog prevent-close v-model="active" @close="active = false">
        <template #header>
          <h4 class="not-margin">
            Eliminar registro
          </h4>
        </template>

        <div class="con-form">
            <h6>¿Esta seguro de eliminar el registro?</h6>
            <p>El registro se eliminara permanentemente.</p>
        </div>

        <template #footer>
          <div class="footer-dialog d-flex">
            <vs-button danger block @click="active = false" style="width: 30%;">
              Cancelar
            </vs-button>
            <vs-button  success class="ml-auto" block @click="postEliminarOfertaNuevo()" style="width: 30%;">
              Aceptar
            </vs-button>
          </div>

        </template>
      </vs-dialog>
    </div>
</template>
<script>
import admisiones from '../../../../../api/requests/admisiones.js'
export default {
    props:[
      'value',
      'selectArrow',
      'csrf_token',
    ],
    data:() => ({
        active: false,
    }),
    methods:{
        async postEliminarOfertaNuevo(){
                const loading = this.$vs.loading()
                try{
                    const formData = new FormData()
                    formData.append('_token', this.csrf_token)
                    const { data: response } = await admisiones.postEliminarOfertaNuevo(this.selectArrow.id, formData)
                    loading.close()
                    this.$emit('refreshTable', this.institucion, this.cicloEscolar)
                    this.active = false
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa',
                        text: 'El registro se eliminó correctamente.'
                    })

                }catch(error){
                    console.log(error)
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Algo salio mal',
                        text: 'Favor de contactar al administrador.'
                    })
                }
        },
    },
    watch:{
        value (val) {
            this.active = val
        },
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
    }
}
</script>